<template>
  <AppDeleteModal
    :loading="isLoading"
    :show="showConfirmDeleteDialog"
    :title="$t('dashboard.delete_module.title')"
    keypath="dashboard.delete_module.message"
    @on-confirm="onConfirmDeleteDashboard"
    @on-close="closeConfirmDeleteDialog"
  >
    <template #i18n-t:moduleName>
      {{ moduleToDelete.name }}
    </template>

    <template #i18n-t:break>
      <br />
    </template>
  </AppDeleteModal>
</template>

<script setup>
import { ref } from 'vue'
// import { useStore } from 'vuex'

import CustomDashboardApiHandler from '@/api/custom-dashboard'
// import { trackDeleteCustomDashboardEvent } from '@/tracking/amplitude-helpers'
import { tracker } from '@/tracking/amplitude'
import { CUSTOM_DASHBOARD_MODULE_TYPES_FOR_TRACKING } from '@/utils/custom-dashboard-helper'
import { handleError } from '@/utils/error-handling'

import AppDeleteModal from '@/components/ui/AppDeleteModal/AppDeleteModal'

defineOptions({
  name: 'RemoveCustomDashboardModule'
})

const props = defineProps({
  showConfirmDeleteDialog: {
    type: Boolean
  },

  moduleToDelete: {
    type: Object,
    default: () => ({})
  },

  dashboardItem: {
    type: Object,
    default: () => ({})
  }
})
const isLoading = ref(false)

const emit = defineEmits(['close', 'confirm', 'on-success'])

const closeConfirmDeleteDialog = () => {
  emit('close')
}
// const store = useStore()
// const isPluginAdmin = computed(() => store.state.pluginOptions.isPluginAdmin)
const onConfirmDeleteDashboard = async () => {
  const customDashboardApi = new CustomDashboardApiHandler()
  try {
    isLoading.value = true
    await customDashboardApi.deleteDashboardModule({
      id: props.dashboardItem.id,
      moduleId: props.moduleToDelete.id
    })

    tracker.logEvent('dashboard module removed', {
      id: props.dashboardItem.id,
      module_type: CUSTOM_DASHBOARD_MODULE_TYPES_FOR_TRACKING[props.moduleToDelete.typeId]
    })

    closeConfirmDeleteDialog()
    // trackDeleteCustomDashboardEvent({
    //   id: props.dashboardForDelete.id,
    //   isPluginAdmin: isPluginAdmin.value,
    // })
    emit('on-success')
  } catch (error) {
    handleError({ error })
  } finally {
    isLoading.value = false
  }
}
</script>

<style lang="scss" scoped></style>
